module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-04.6e9d3f87.png";